import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { statusOptions } from "pages/billingInvocies/helper";
import React from "react";

const BillingInvocieSearch = ({
  fetchInvoices,
  setFilters,
  setFilterOpen,

  filterOpen,
  tempFilters,
  setTempFilters,
}) => {
  const handleApplyFilters = () => {
    setFilters(tempFilters);

    const appliedFilters = {};

    if (tempFilters.patient_id) {
      appliedFilters.patient_id = tempFilters.patient_id;
    }
    if (tempFilters.bill_invoice_id) {
      appliedFilters.bill_invoice_id = tempFilters.bill_invoice_id;
    }
    if (tempFilters.patient_name) {
      appliedFilters.patient_name = tempFilters.patient_name;
    }
    if (tempFilters.status) {
      appliedFilters.status = tempFilters.status;
    }
    if (tempFilters.bill_date) {
      appliedFilters.bill_date = dayjs(tempFilters.bill_date).format(
        "MM/DD/YYYY"
      );
    }
    if (tempFilters.billing_amount) {
      appliedFilters.billing_amount = tempFilters.billing_amount;
    }

    setFilterOpen(false);
    fetchInvoices(appliedFilters);
  };

  return (
    <Dialog
      open={filterOpen}
      onClose={() => setFilterOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Filter Invoices</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="Patient Name"
            value={tempFilters.patient_name}
            onChange={(e) =>
              setTempFilters({
                ...tempFilters,
                patient_name: e.target.value,
              })
            }
            fullWidth
          />
          <TextField
            label="Patient Id"
            value={tempFilters.patient_id}
            onChange={(e) =>
              setTempFilters({
                ...tempFilters,
                patient_id: e.target.value,
              })
            }
            fullWidth
          />
          <TextField
            label="Bill Invoice Id"
            value={tempFilters.bill_invoice_id}
            onChange={(e) =>
              setTempFilters({
                ...tempFilters,
                bill_invoice_id: e.target.value,
              })
            }
            fullWidth
          />

          <Select
            value={tempFilters.status}
            onChange={(e) =>
              setTempFilters({ ...tempFilters, status: e.target.value })
            }
            displayEmpty
            fullWidth
          >
            <MenuItem value="">
              <em>Status</em>
            </MenuItem>
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>

          <DatePicker
            label="Bill Date"
            value={tempFilters.bill_date}
            onChange={(newValue) =>
              setTempFilters({ ...tempFilters, bill_date: newValue })
            }
            format="MM/DD/YYYY"
          />

          <TextField
            label="Billing Amount"
            type="number"
            value={tempFilters.billing_amount}
            onChange={(e) =>
              setTempFilters({
                ...tempFilters,
                billing_amount: e.target.value,
              })
            }
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setFilterOpen(false)}>Cancel</Button>
        <Button onClick={handleApplyFilters} variant="contained">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BillingInvocieSearch;
